// Routes
const ROUTES = {
  core_v2: {

    transportOrders: {
      complete_delivery_process: '/transport-orders/complete-delivery-process'
    },

    get_wizard_config: 'wizard/available-solutions/order/{id}',
    resolve_wizard: 'wizard/resolve',
    summary: 'wizard/summary/{id}',

    products: {
      get_eans_by_pet: 'orders/get-eans-by-pet'
    }
  },

  inventory: {
    get_inventory_dashboard: 'inventory/dashboard',
    get_products_pets: 'inventory/products-pets/{id}',
    get_stock_config_values: 'inventory/stock-config-values',
    update_stock_config: 'inventory/update-stock-config'
  },

  supplier: {
    get_price_config_values: 'supplier/price-config-values',
    update_price_config: 'supplier/update-price-config',
    bulk_update_price_config: 'supplier/bulk-update-price-config'
  },

  petshops: {
    get_orders: 'orders/logistics-list',
    get_packing_order_statuses: 'packing-orders/statuses',
    get_transport_order_statuses: 'transport-orders/statuses',
    generate_labels: 'packing-orders/generate-labels',
    repackage: 'packing-orders/repackage'
  },

  addresses: {
    get_localities: 'addresses/localities',
    get_neighborhoods: 'addresses/neighborhoods'
  },

  customer: {
    change_packing_order_status: 'packing-orders/bulk-change-status',
    change_transport_order_status: 'transport-orders/bulk-change-status'
  },

  delivery_drivers: {
    get_drivers: 'delivery-drivers/drivers'
  },

  delivery_times: {
    get_delivery_times: 'delivery-times'
  }
};

export default ROUTES;
